(function () {
  var selector = "#smile-ui-lite-launcher-frame-container, #smile-ui-container .smile-launcher-frame-container";
  var launchers = new Set();
  var pending = false;
  var resizeObserver = typeof ResizeObserver === "function" ? new ResizeObserver(schedule) : null;

  function update() {
    pending = false;
    var targetSize = parseFloat(getComputedStyle(document.documentElement).getPropertyValue("--zv-smile-size"));
    if (!Number.isFinite(targetSize) || targetSize <= 0) return;

    launchers.forEach(function (launcher) {
      if (!launcher.isConnected) {
        if (resizeObserver) resizeObserver.unobserve(launcher);
        launchers.delete(launcher);
        return;
      }

      var nativeSize = launcher.offsetHeight;
      if (!nativeSize) return;
      var scale = String(targetSize / nativeSize);
      if (launcher.style.getPropertyValue("--zv-smile-launcher-scale") !== scale) {
        launcher.style.setProperty("--zv-smile-launcher-scale", scale);
      }
    });
  }

  function schedule() {
    if (pending) return;
    pending = true;
    requestAnimationFrame(update);
  }

  function track(launcher) {
    if (launchers.has(launcher)) return;
    launchers.add(launcher);
    if (resizeObserver) resizeObserver.observe(launcher);
    schedule();
  }

  function scan(node) {
    if (node.nodeType !== 1) return;
    if (node.matches(selector)) track(node);
    node.querySelectorAll(selector).forEach(track);
  }

  document.querySelectorAll(selector).forEach(track);
  new MutationObserver(function (records) {
    records.forEach(function (record) {
      record.addedNodes.forEach(scan);
    });
  }).observe(document.body, { childList: true, subtree: true });

  window.addEventListener("resize", schedule, { passive: true });
  window.addEventListener("pageshow", schedule);
  document.addEventListener("shopify:section:load", schedule);
})();
